module.exports = __webpack_public_path__ + "static/media/lo1v36.ebaf5900.png";